import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import UserConsultationTab from "../Components/UserConsultationTab";
import { chat, consultantmage, file } from "../Constant/Index";
import Toggle from "../Components/Toggle";
import { patientBookapointmentdetail } from "../network/Network";
import { useDispatch, useSelector } from "react-redux";
import { ORDER_DETAIL } from "../redux/Slices/AuthSlice";

const UserConsultationDetail = () => {
	const dispatch = useDispatch();
	const token = useSelector((state) => state?.Auth?.token);
	const [getappointdetail, setGetappointdetail] = useState("");

	// Safely parse the JSON
	let specialties = [];
	try {
		const specialization = getappointdetail?.physician_detail?.specialization;
		specialties = specialization ? JSON.parse(specialization) : [];
	} catch (error) {}

	let currentUrl = window.location.href.split("/");

	// Get Appoitment detail Api
	useEffect(() => {
		patientBookapointmentdetail(currentUrl[4], token).then((res) => {
			dispatch(ORDER_DETAIL(res?.data));
			setGetappointdetail(res?.data);
		});
	}, [currentUrl[4]]);
	// ====================
	console.log(getappointdetail, "getappointdetail");
	return (
		<>
			<Header />
			<PageHeader pagename="User Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	 mb-3">
									<div className="edit-btn back">
										<Link to="/my-consultations">
											<div className="nav-anchor">
												<i className="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									<div className="d-flex align-items-center  justify-content-between w-100">
										<h5 className="main-heading level-6 ps-3 main-heading-font dark-color mb-0 wow animate__animated animate__zoomIn animate__delay-1s ">
											My Consultations
										</h5>
										{/* <UserConsultationTab /> */}
									</div>
								</div>
								<div className="row">
									<div className="col-lg-12">
										<div className="content-qty extra-bg-14 radius-20 p-4 dark-color ">
											<div className="d-flex gap-3 align-items-center">
												<img
													src={
														getappointdetail?.physician_detail
															?.profile_image_url || consultantmage
													}
													className="img-fluid"
													alt=""
													style={{
														width: "70px",
														height: "70px",
														borderRadius: "50%",
													}}
												/>
												<div>
													<h4 className="main-heading-font level-6 ">
														{getappointdetail?.physician_detail?.title}
													</h4>
													<div className="prescription_dv_show d-flex">
														{specialties.map((specialty, index) => (
															<h5 className="primary-medium-font level-8 extra-color-10 me-2">
																{specialty}
															</h5>
														))}
													</div>
													{getappointdetail?.physician_detail?.address !==
														null && (
														<h4 className="primary-medium-font level-7 ">
															<span className="icon-point">
																<i className="fa-solid fa-location-dot"></i>
															</span>{" "}
															{getappointdetail?.physician_detail?.address}
														</h4>
													)}
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row  pt-5  border-bottom pb-4">
									<div className="col-lg-12">
										<div className="order-detail-content">
											<div className="row">
												<div className="col-lg-12">
													<div className="details-pharmacy">
														<h4 className="main-heading-font level-6 ">
															Specialty
														</h4>
														{specialties.map((specialty, index) => (
															<h5 className="primary-medium-font level-8 extra-color-10">
																{specialty}
															</h5>
														))}
													</div>
												</div>
												<div className="col-lg-12 mt-3">
													<div className="details-pharmacy">
														<h4 className="main-heading-font level-6 ">
															Qualification
														</h4>
														<h5 className="primary-medium-font level-8 extra-color-10">
															{getappointdetail?.physician_detail?.degree_title}
														</h5>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row border-top pt-4  pb-4">
									<div className="col-lg-12">
										<div className="order-detail-content">
											<div className="row">
												<div className="col-lg-12">
													<div className="details-pharmacy">
														<h4 className="main-heading-font level-6 ">
															Symptoms
														</h4>
														<h5 className="primary-medium-font level-8 extra-color-10">
															{getappointdetail?.booking_detail?.symptoms?.join(
																", ",
															)}
														</h5>
													</div>
												</div>
												<div className="col-lg-12 mt-3">
													<div className="details-pharmacy">
														<h4 className="main-heading-font level-6 ">
															Details
														</h4>
														<h5 className="primary-medium-font level-8 extra-color-10">
															{getappointdetail?.booking_detail?.detail}
														</h5>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row mt-4">
									<div className="col-lg-12">
										<Link
											className="detail-physician-btn calender-bg extra-bg-14 w-100 d-flex align-items-center justify-content-center"
											href="/consultation-detail"
										>
											<span>
												<i className="fa-regular fa-calendar"></i>{" "}
											</span>
											{/* Sun - May 10, 1:00pm - 2:00pm */}
											{getappointdetail?.booking_detail?.booking_day}{" "}
											{/* {new Date(
												getappointdetail?.booking_detail?.booking_date,
											).toLocaleDateString("en-GB", {
												day: "2-digit",
												month: "long",
												year: "numeric",
											})}{" "} */}
											{getappointdetail?.booking_detail?.booking_date} (
											{getappointdetail?.booking_detail?.booking_time})
										</Link>
									</div>
								</div>
								{getappointdetail?.booking_detail?.appointment_status ==
								"Past" ? (
									<>
										<div className="row mt-2">
											<div className="col-lg-12">
												<div className="d-flex align-items-center gap-3">
													<Link
														className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
														href="/current-consultations-detail"
														to="/user-prescription"
													>
														<span className="bg-wrapper w-100">
															{" "}
															<img
																src={file}
																className="img-fluid pe-3"
																alt=""
															/>{" "}
															View Prescription{" "}
														</span>
													</Link>
													<Link
														className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
														href="/current-consultations-detail"
														to="/user-notes"
													>
														<span className="bg-wrapper w-100">
															<img
																src={file}
																className="img-fluid pe-3"
																alt=""
															/>
															View Notes
														</span>
													</Link>
												</div>
											</div>
										</div>
										<div className="row mt-4">
											<div className="col-lg-12">
												<Link
													className="color-view-details detail-physician-btn calender-bg  w-100 d-flex align-items-center justify-content-center dark-color"
													to="/user-chat"
													state={{
														tabName:
															getappointdetail?.booking_detail
																?.appointment_status,
													}}
												>
													<span>
														<img src={chat} alt="" className="img-fluid" />
													</span>
													View Chat
												</Link>
											</div>
										</div>
									</>
								) : null}
								{getappointdetail?.booking_detail?.appointment_status ==
								"Current" ? (
									<>
										<div className="row mt-4">
											<div className="col-lg-12">
												<Link
													className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
													href="/current-consultations-detail"
													to="/user-chat"
													state={{
														tabName:
															getappointdetail?.booking_detail
																?.appointment_status,
													}}
												>
													<span className="bg-wrapper w-100">Open Chat</span>
												</Link>
												<Link
													className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
													href="/current-consultations-detail"
													to="/user-notes"
												>
													<span className="bg-wrapper w-100">
														{" "}
														<img
															src={file}
															className="img-fluid pe-3"
															alt=""
														/>{" "}
														View Notes
													</span>
												</Link>
											</div>
										</div>
									</>
								) : null}
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserConsultationDetail;
